const commuRoutes = [
  {
    path: "/commu",
    name: "commu",
    meta: {
      title: "커뮤니티",
      isDynamic: false,
    },
    children: [
      /** 공지사항 목록 */
      {
        path: "notice", // /commu/notice
        name: "studentNoticeIndex",
        meta: {
          title: "공지사항",
          titleEn: "Notice",
          menuCd: "STUDENT_COMM_NOTICE",
          isDynamic: false,
        },
        children: [
          {
            path: "",
            meta: {
              title: "공지사항",
              titleEn: "Notice",
              menuCd: "STUDENT_COMM_NOTICE",
              isDynamic: false,
            },
            component: () => import("@/views/student/commu/notice/StudentNotice.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "공지사항",
              titleEn: "Notice Detail",
              menuCd: "STUDENT_COMM_NOTICE",
              isDynamic: false,
            },
            component: () => import("@/views/student/commu/notice/StudentNoticeDetail.vue"),
          },
        ],
      },
      {
        path: "qna", // /commu/qna
        name: "studentQnaIndex",
        meta: {
          title: "Q&A",
          titleEn: "Q&A",
          menuCd: "STUDENT_COMM_QNA",
          isDynamic: true,
        },
        children: [
          {
            path: "",
            meta: {
              title: "Q&A",
              titleEn: "Q&A",
            },
            component: () => import("@/views/student/commu/qna/StudentQna.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "상세",
              titleEn: "Q&A Detail",
              isDynamic: true,
            },
            component: () =>
              import("@/views/student/commu/qna/StudentQnaDetail.vue"),
          },
          {
            path: "create",
            meta: {
              title: "등록",
              titleEn: "Q&A create",
              isDynamic: true,
            },
            component: () =>
              import("@/views/student/commu/qna/StudentQnaWrite.vue"),
          },
        ],
      },
      {
        path: "alert", // /commu/alert
        name: "studentAlertIndex",
        meta: {
          title: "알림톡",
          titleEn: "Alert",
          menuCd: "STUDENT_COMM_ALERT",
          isDynamic: true,
        },
        children: [
          {
            path: "",
            meta: {
              title: "알림톡",
              titleEn: "Alert",
            },
            component: () =>
              import("@/views/student/commu/alert/StudentAlarmTalk.vue"),
          },
        ],
      },
      {
        path: "certi",
        name: "studentCertificationIndex",
        meta: {
          title: "우수 교육인증 프로그램",
          titleEn: "Excellence in Education Certification Program",
          menuCd: "STUDENT_COMM_CERTI",
          isDynamic: false,
        },
        children: [
          {
            path: "",
            meta: {
              title: "우수 교육인증 프로그램",
              isDynamic: false,
            },
            component: () => import("@/views/student/commu/certi/EduCertiIndex.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "우수 교육인증 프로그램 조회",
              isDynamic: false,
            },
            component: () => import("@/views/student/commu/certi/EduCertiDetail.vue"),
          },
        ],
      },
      /** 공지사항 상세 */
    ],
  },
];

export default commuRoutes;
